import styled from 'styled-components'
import { motion } from 'framer-motion'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'

export const TtsFlyoutActionButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;

  .cancel-button {
    padding: 8px 11px;
  }

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    flex-direction: column-reverse;
    gap: 12px;

    .button {
      width: 100%;
      height: 40px;
    }
  }
`

export const ButtonWithTooltipWrapper = styled.div`
  position: relative;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
  }
`

export const CustomTooltipWrapper = styled(motion.div)`
  position: absolute;
  max-width: max-content;
  width: 250px;
  padding: 8px;
  background: ${COLORS.secondaryDark};
  border-radius: 8px;
  color: ${COLORS.white};
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  top: -100%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
`

export const TooltipArrow = styled.div`
  width: 8px;
  height: 8px;
  position: absolute;
  background: ${COLORS.secondaryDark};
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
`
